export default "__VITE_ASSET__DqtZZJ22__"